import { types, actions } from './requests'
export const UPDATEJOB_TYPES = {
    ...types('UPDATEJOB'),
}
export const UPDATEJOB_ACTIONS = {
    ...actions('UPDATEJOB'),
}
